import { TextField, RadioGroupField } from '~/common/components';
import { useI18n, Trans } from '~/common/context';
import { Card, Col, Row } from '@wyz/ui';
import { Title } from '@wyz/ui';
import { CIVILITY_LABEL } from '~/purchase/schemas';
import { IQuoteSetting } from '~/purchase/types';

function ContactForm({ settings }: { settings: IQuoteSetting }) {
  const { t } = useI18n();
  return (
    <Card>
      <Card.Body>
        <Title heading='lg' weight='bold' color='secondary'>
          <Trans i18nKey='app.purchase.quote_cart_page.contact.identity' />
        </Title>
        <Row>
          <Col>
            <TextField
              name='contact.registration'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.matriculation.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.matriculation.placeholder',
              )}
              required={settings.vehicleRegistrationRequired}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <RadioGroupField
              name='contact.civility'
              options={Object.entries(CIVILITY_LABEL).map(([key, value]) => ({
                value: key,
                label: t(value),
              }))}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField
              name='contact.firstName'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.firstname.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.firstname.placeholder',
              )}
              required={settings.fullNameRequired}
            />
          </Col>
          <Col>
            <TextField
              name='contact.lastName'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.lastname.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.lastname.placeholder',
              )}
              required={settings.fullNameRequired}
            />
          </Col>
        </Row>
        <Title heading='lg' weight='bold' color='secondary'>
          <Trans i18nKey='app.purchase.quote_cart_page.contact.coordinates' />
        </Title>
        <Row>
          <Col>
            <TextField
              name='contact.phone'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.phone.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.phone.placeholder',
              )}
              required={settings.phoneNumberRequired}
            />
          </Col>
          <Col>
            <TextField
              name='contact.email'
              label={<Trans i18nKey='app.common.email' />}
              placeholder={t(
                'app.purchase.quote_cart_page.contact.mail.placeholder',
              )}
              required={settings.emailRequired}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField
              name='contact.company'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.company.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.company.placeholder',
              )}
            />
          </Col>
          <Col>
            <TextField
              name='contact.address'
              label={
                <Trans i18nKey='app.purchase.quote_cart_page.contact.address.label' />
              }
              placeholder={t(
                'app.purchase.quote_cart_page.contact.address.placeholder',
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextField
              name='contact.zipCode'
              label={<Trans i18nKey='app.common.customer.zip_code' />}
              placeholder={t(
                'app.purchase.quote_cart_page.contact.zip_code.placeholder',
              )}
            />
          </Col>
          <Col>
            <TextField
              name='contact.city'
              label={<Trans i18nKey='app.common.customer.city' />}
              placeholder={t(
                'app.purchase.quote_cart_page.contact.city.placeholder',
              )}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default ContactForm;
